export class NoResults {
  isError = false;
  isRobotSnippet = false;
  customRobotClass: string;
  isRobotTopMargin = false;
  robotHeight: string | number;
  robotWidthPx: string | number;
  robotWidthPercent: string | number;
  errorHeightMarginTop: string | number;
  errorMessage = 'There are no results';
  errorFontSize: string | number;
  customErrorClass: string;

  constructor(
    {
      isError = null,
      isRobotSnippet = null,
      isRobotTopMargin = null,
      customRobotClass = null,
      robotHeight = null,
      robotWidthPx = null,
      robotWidthPercent = null,
      errorHeightMarginTop = null,
      errorMessage = null,
      errorFontSize = null,
      customErrorClass = null
    }: {
      isError?: boolean;
      isRobotSnippet?: boolean;
      customRobotClass?: string;
      isRobotTopMargin?: boolean;
      robotHeight?: string | number;
      robotWidthPx?: string | number;
      robotWidthPercent?: string | number;
      errorHeightMarginTop?: string | number;
      errorMessage?: string;
      errorFontSize?: string | number;
      customErrorClass?: string
    }) {
    this.isError = isError != null ? isError : this.isError;
    this.isRobotSnippet = isRobotSnippet != null ? isRobotSnippet : this.isRobotSnippet;
    this.customRobotClass = customRobotClass != null ? customRobotClass : this.customRobotClass;
    this.isRobotTopMargin = isRobotTopMargin != null ? isRobotTopMargin : this.isRobotTopMargin;
    this.robotHeight = robotHeight != null ? robotHeight : this.robotHeight;
    this.robotWidthPx = robotWidthPx != null ? robotWidthPx : this.robotWidthPx;
    this.robotWidthPercent = robotWidthPercent != null ? robotWidthPercent : this.robotWidthPercent;
    this.errorHeightMarginTop = errorHeightMarginTop != null ? errorHeightMarginTop : this.errorHeightMarginTop;
    this.errorMessage = errorMessage != null ? errorMessage : this.errorMessage;
    this.errorFontSize = errorFontSize != null ? errorFontSize : this.errorFontSize;
    this.customErrorClass = customErrorClass != null ? customErrorClass : this.customErrorClass;
  }
}
